import { render, staticRenderFns } from "./logs_list.vue?vue&type=template&id=72dd9d2c&"
import script from "./logs_list.vue?vue&type=script&lang=js&"
export * from "./logs_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports